import Hero from "@/components/Hero";
import CriticalMineralsDashboard from "@/components/CriticalMineralsDashboard";
import SummaryCards from "@/components/SummaryCards";
import DailyDrilldown from "@/components/DailyDrilldown";
import ProjectWatchPreview from "@/components/ProjectWatchPreview";
import NewsletterCTA from "@/components/NewsletterCTA";
import SEO, { websiteSchema } from "@/components/SEO";

export default function Home() {
  return (
    <div data-testid="home-page">
      <SEO
        title={null}
        description="Tracking the projects, policies, commodities, and companies shaping Canada's mining sector — from Canadian Shield exploration to Parliament Hill permitting."
        type="website"
        jsonLd={websiteSchema()}
      />
      <Hero />
      <CriticalMineralsDashboard />
      <SummaryCards />
      <DailyDrilldown />
      <ProjectWatchPreview />
      <NewsletterCTA />
    </div>
  );
}
